enum FeatureLayout {
    LAYOUT1 = 1,
    LAYOUT2 = 2,
    LAYOUT3 = 3
}

export default FeatureLayout;